/**
 * tdesign v0.46.2
 * (c) 2022 tdesign
 * @license MIT
 */

import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { renderTNodeJSX } from '../utils/render-tnode.js';
import { getClassPrefixMixins } from '../config-provider/config-receiver.js';
import mixins from '../utils/mixins.js';
import '@babel/runtime/helpers/typeof';
import 'vue';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import 'lodash/mergeWith';
import '../config-provider/context.js';
import 'lodash/merge';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../config-provider/type.js';

var classPrefixMixins = getClassPrefixMixins("input-group");
var _InputGroup = mixins(classPrefixMixins).extend({
  name: "TInputGroup",
  props: {
    separate: {
      type: Boolean,
      "default": false
    }
  },
  computed: {
    classes: function classes() {
      return [this.componentName, _defineProperty({}, "".concat(this.componentName, "--separate"), this.separate)];
    }
  },
  render: function render() {
    var h = arguments[0];
    return h("div", {
      "class": this.classes
    }, [renderTNodeJSX(this, "default")]);
  }
});

export { _InputGroup as default };
//# sourceMappingURL=input-group.js.map
